import React from 'react';
import { formatRateRange } from '../seeker/details/New_UI/Components/util';

const tileBaseClass =
  "min-w-[170px] w-auto max-w-fit py-2 px-4 rounded-lg flex flex-col items-center text-center h-fit self-start";

const PayRateTiles = ({ payRate }: any) => {
    return (
        <>
            {payRate?.salary && (
                <div
                    style={{ backgroundColor: "#3E4C9533" }}
                    className={`${payRate?.commission ? "cursor-pointer" : ""} bg-[#3E4C9533] ${tileBaseClass}`}
                >
                    <p className="text-instant-teams-blue-Main text-sm leading-5 min-h-[20px]">
                        Salary
                    </p>
                    <p className="font-semibold text-instant-teams-blue-Main leading-6 min-h-[24px] whitespace-nowrap">
                        {formatRateRange("salary", payRate?.salary, true)}
                    </p>
                    <p className="text-instant-teams-blue-Main text-center text-[10px] leading-4 min-h-[16px] whitespace-nowrap">
                        {(payRate?.commission || payRate?.additionalBenifits)
                            ? (payRate?.additionalBenifits === "empBO"
                                ? "This position offers a base salary plus additional bonus opportunities."
                                : "This position offers a base salary plus additional commission opportunities.")
                            : "This position offers a fixed annual salary."}
                    </p>
                </div>
            )}
            {payRate?.hourly && (
                <div
                    style={{ backgroundColor: "#3E4C9533" }}
                    className={`bg-[#3E4C9533] ${tileBaseClass}`}
                >
                    <p className="text-instant-teams-blue-Main text-sm leading-5 min-h-[20px]">
                        Hourly
                    </p>
                    <p className="font-semibold text-instant-teams-blue-Main leading-6 min-h-[24px] whitespace-nowrap">
                        {formatRateRange("hoursPerWeek", payRate?.hourly, true)} / Hr
                    </p>
                    <p className="text-instant-teams-blue-Main text-center text-[10px] leading-4 min-h-[16px] whitespace-nowrap">
                        {(payRate?.commission || payRate?.additionalBenifits)
                            ? (payRate?.additionalBenifits === "empBO"
                                ? "This position offers a base salary plus additional bonus opportunities."
                                : "This position offers a base salary plus additional commission opportunities.")
                            : "This position offers an hourly wage."}
                    </p>
                </div>
            )}
            {payRate?.commission && !payRate?.salary && !payRate?.hourly && (
                <div
                    style={{ backgroundColor: "#3E4C9533" }}
                    className={`bg-[#3E4C9533] ${tileBaseClass}`}
                >
                    <p className="text-instant-teams-blue-Main text-sm leading-5 min-h-[20px]">
                        Pay
                    </p>
                    <p className="font-semibold text-instant-teams-blue-Main leading-6 min-h-[24px] whitespace-nowrap">
                        Commission Only
                    </p>
                    <p className="text-instant-teams-blue-Main text-center text-[10px] leading-4 min-h-[16px] whitespace-nowrap">
                        This is a commission-only role with earnings based on performance.
                    </p>
                </div>
            )}
            {payRate?.type == "unpaid_internship" && (
                <div
                    style={{ backgroundColor: "#3E4C9533" }}
                    className={`bg-[#3E4C9533] ${tileBaseClass}`}
                >
                    <p className="text-instant-teams-blue-Main text-sm leading-5 min-h-[20px]">
                        Salary
                    </p>
                    <p className="font-semibold text-instant-teams-blue-Main leading-6 min-h-[24px] whitespace-nowrap">
                        Unpaid Internship
                    </p>
                    <p className="text-xs leading-4 min-h-[16px]">{"\u00A0"}</p>
                </div>
            )}
        </>
    );
}

export default PayRateTiles;
